import { ZfDropdown, ZfDropdownItem } from '@zafire/react';
import type { CSSProperties, FunctionComponent } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AddEventFlowModal } from './AddEventFlowModal';
import { AddNeedFlowModal } from './AddNeedFlowModal';

interface IProps {
    addBtnStyle?: CSSProperties;
}

export const AddEventNeedButton: FunctionComponent<IProps> = ({ addBtnStyle = {} }) => {
    const { t } = useTranslation();
    const [isSelectEventModalOpen, setIsSelectEventModalOpen] = useState(false);
    const [isSelectNeedModalOpen, setIsSelectNeedModalOpen] = useState(false);

    const onAddEvent = () => setIsSelectEventModalOpen(true);
    const onAddNeed = () => setIsSelectNeedModalOpen(true);

    return (
        <>
            <ZfDropdown side="left" text={t('add')} icon="add" hierarchy="secondary" style={addBtnStyle} className="ml-auto">
                <ZfDropdownItem label={t('lifeEvent')} onDropdownItemSelect={onAddEvent} />
                <ZfDropdownItem label={t('ADVISORY_NEED_TASK')} onDropdownItemSelect={onAddNeed} />
            </ZfDropdown>

            {isSelectEventModalOpen && <AddEventFlowModal onClose={() => setIsSelectEventModalOpen(false)} />}
            {isSelectNeedModalOpen && <AddNeedFlowModal onClose={() => setIsSelectNeedModalOpen(false)} />}
        </>
    );
};
